import { action, makeObservable, observable } from 'mobx';
import { SolgariApiService } from '../services/solgari-api/solgari-api.service';
import { RootStore } from './RootStore';
import { ITranscriptAnalyticsApi } from '../services/solgari-api/interfaces/transcript-analytics.interface';

interface SessionsAnalyticsListItem {
  sessionId: string;
  analytics: ITranscriptAnalyticsApi;
}

class TranscriptStore {
  @observable
  isLoading: boolean;

  @observable
  currentSessionsAnalytics: ITranscriptAnalyticsApi | null;

  @observable
  sessionsAnalyticsList: SessionsAnalyticsListItem[];

  @action
  getCallSessionTranscript = async (sessionId: string) => {
    this.isLoading = true;

    const foundAnalytics = this.sessionsAnalyticsList.find(
      (item) => item.sessionId === sessionId,
    );

    if (foundAnalytics) {
      this.currentSessionsAnalytics = foundAnalytics.analytics;

      this.isLoading = false;
      return;
    }

    const response =
      await SolgariApiService.getCallSessionTranscript(sessionId);

    if (response) {
      this.sessionsAnalyticsList = [
        ...this.sessionsAnalyticsList,
        {
          sessionId,
          analytics: response,
        },
      ];
    }

    this.currentSessionsAnalytics = response;
    this.isLoading = false;
  };

  constructor(public root: RootStore) {
    this.isLoading = false;
    this.sessionsAnalyticsList = [];

    makeObservable(this);
  }
}

export default TranscriptStore;
